// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("assets/images/icons/icon-openmap.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".icon-open{position:absolute;width:44px;height:44px;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-size:contain}@media(min-width:0em){.icon-open{top:20px}}@media(min-width:68.75em){.icon-open{top:30px}}@media(min-width:0em){.icon-open{left:20px}}@media(min-width:68.75em){.icon-open{left:30px}}", ""]);
// Exports
module.exports = exports;
